'use client';

import { BuilderComponent, useIsPreviewing } from '@builder.io/react';
import { builder } from '@builder.io/sdk';
import '@builder.io/widgets';

import './components/blocks';
import { StatsigExperimentContext } from './components/context/NavSearchContext';

//TODO: abstract out builder init to config/secret

export interface BuilderPageProps {
    content: any;
    modelName?: string;
    apiKey?: string;
    countryCode: string;
    data?: any;
    flags?: Record<string, boolean>;
}

// Using <Link/> was causing search pages to pre-fetch and trigger extra search events.
// Temporarily removing this until we come up with a long term solution.
// function CustomLink(props: any) {
//     return <Link {...props} />;
// }

export default function RenderBuilderContent({
    content,
    modelName = 'page',
    apiKey,
    countryCode,
    data,
    flags = {},
}: BuilderPageProps) {
    if (!apiKey) {
        throw new Error('Builder API key is not provided.');
    }
    builder.init(apiKey);
    builder.apiVersion = 'v3';
    const isPreviewing = useIsPreviewing();

    const show404 = !content && !isPreviewing;

    if (!show404) {
        return (
            <StatsigExperimentContext.Provider value={flags}>
                <BuilderComponent content={content} model={modelName} locale={countryCode} data={data} />
            </StatsigExperimentContext.Provider>
        );
    } else {
        //notFound();
    }
}

export function setBuilderUserAttributes(options: Record<string, string | boolean>) {
    builder.setUserAttributes(options);
}
